import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { environment } from "../../environments/environment";

// Bookmarks of the old /quota/prep/* URLs should land on the new betui app.
// When BetUiUrl is configured (Test/Prod) we hop out to <betUiUrl>/quota/<path>
// and abort in-app activation. Otherwise (local dev) we keep the legacy route.
export const RedirectToBetUiGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const betUiUrl: string | undefined = (environment as any).betUiUrl;
  if (!betUiUrl) return true;

  const root = (environment as any).siteRootPath || "/quota";
  window.location.replace(`${betUiUrl}${root}${state.url}`);
  return false;
};
